export default __webpack_public_path__ + "static/media/sola.0b5e3dd3.png";